import { isRejectedWithValue, isFulfilled } from '@reduxjs/toolkit';
import { parseInt } from 'lodash';
import PATH from '../shared/constants/path.const';
import ApplicationLogout from '../pages/common/logout/ApplicationLogout';

const parseVersion = (version) => {
  const parts = version?.replace(/[vV]/g, '').split('.');
  return {
    first: parseInt(parts?.[0] || 0),
    second: parseInt(parts?.[1] || 0),
    third: parseInt(parts?.[2] || 0),
  };
};

const isHeaderVersionNewer = (headerVrsn, localVrsn) => {
  const header = parseVersion(headerVrsn);
  const local = parseVersion(localVrsn);

  return (
    header.first > local.first ||
    (header.first === local.first && header.second > local.second) ||
    (header.first === local.first && header.second === local.second && header.third > local.third)
  );
};

const authenticationMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (isFulfilled(action)) {
      // Mocked endpoints (queryFn) have no HTTP response, hence no headers.
      const headerV = action.meta?.baseQueryMeta?.response?.headers?.get('Version');
      const localV = localStorage.getItem('appV') || '0';

      if (headerV && isHeaderVersionNewer(headerV, localV)) {
        localStorage.setItem('appV', headerV);
        window.location.reload();
      }
    }
    if (isRejectedWithValue(action)) {
      if (action.payload.status === 401) {
        window.location.href = PATH.AUTH.LOGIN;
        ApplicationLogout(dispatch);
      }
    }

    return next(action);
  };

export default authenticationMiddleware;
